
import { defineComponent } from 'vue';
import { eventBus, Events } from '@/events';
import { FocusTrap } from 'focus-trap-vue';
import SadButton from './SadButton.vue';
import SadIcon from './SadIcon.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'SadDrawer',
  components: {
    FocusTrap,
    SadButton,
    SadIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['close'],

  setup(props, { emit }) {
    const { t } = useI18n();

    eventBus.on(Events.CLOSE_DRAWER_MODAL, () => {
      if (props.show) {
        emit('close');
      }
    });

    return { t };
  },
});
